<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      {{data.showName}}
    </div>
    <div>
      <ejs-dropdownlist :fields='fields' :dataSource='data.options' :enabled='disabledReadonly' :name='data.name' :value='data.value' v-model='params.paramVal' @change="selectChange" :ref="data.name"/>
    </div>
    <!--<button @click="getParams">GetParam</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_Select',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
      fields: { text: 'showName', value: 'value' },
    };
  },
  computed: {
    disabledReadonly() {
      return (this.data.readonly || this.data.disabled) === true ? false : true;
    }
  },
  methods: {
    selectChange() {
      if (this.data.changeClick === true) {
        if (this.data.options === undefined) return;
        for (const option of this.data.options) {
          if (option.value === this.params.paramVal) {
            this.$parent.$childSelectChange(option.attr);
            break;
          }
        }
      }
      try {
        this.changeFunc();
      } catch (e) {
        console.log('subscriber error. bind onChange Func error');
      }
    }
  },
  created() {
    this.$parseInitData();
  }
};
</script>

<style scoped>

</style>
